import {Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-warehouse-transactions-all",
    template: `
        <section-warehouse-transactions-list [params]='{title: "All transactions", type: "", state: state}'>
        </section-warehouse-transactions-list>`
})
export class WarehouseTransactionsListAllComponent implements Base.IComponent {

    public readonly state: Base.IState;

    public ngConfig(): Base.IConfig {
        return {
            name: "transactions-all",
            actions: {
                "browse": ["browse_warehouse_transactions"]
            }
        };
    }

}
